import { useQuery } from "@tanstack/react-query";

import { videoService } from "../api/videoService";

/**
 * 「AI 智能编排(分镜+台本图)」这一步的花费区间 —— 全站唯一出处是 ai 侧
 * `app.modules.video.application.compose_estimate`(军师确认卡走的是同一个对象,见那边头注)。
 *
 * ★ 静态常量、无租户维度、不计费:与 `VideoCreatePage` 里已有的 `taxonomyQuery`
 *   (`GET /video/creative-taxonomy`)同款,`staleTime: Infinity` —— 这两个数字不会在会话
 *   期间变,拉一次够用一整个会话,不必每次挂载都重拉。
 * ★ 取不到价 → `data` 为 `null`,调用方**不显示数字**(不兜旧值、不兜写死的 700/1900 ——
 *   那样 ai 侧改了数,创建页仍显示旧值,又制造一个「两处数字打架」)。
 * ★0904:多出的 `failed` 字段区分「还没拉回来」与「重试一次后落定失败」——`composeEstimateCaption`
 *   据此在真失败时换成兜底句,而不是让这句话在整场会话里彻底消失
 *   (`retry:1` 落定 `isError` 之后不会自愈,见那两个函数头注)。
 */
export function useComposeEstimate(): {
  low: number | null;
  high: number | null;
  loading: boolean;
  failed: boolean;
} {
  const query = useQuery({
    queryKey: ["video", "compose-estimate"],
    queryFn: () => videoService.getComposeEstimate(),
    staleTime: Infinity,
    retry: 1,
  });
  return {
    low: query.data?.low ?? null,
    high: query.data?.high ?? null,
    loading: query.isLoading,
    failed: query.isError,
  };
}
